export const getRecordsPerPage = ()=>{
    const recordsPerPage = 15
    return recordsPerPage
}